/* Copyright (c) 2024 Xperi. All Rights Reserved. */

export const SETTINGS_VIDEO_WINDOW_SET_ACTIVE = 'SETTINGS_VIDEO_WINDOW_SET_ACTIVE';
export const SETTINGS_VIDEO_WINDOW_SET_GHOST_MODE = 'SETTINGS_VIDEO_WINDOW_SET_GHOST_MODE';
export const SETTINGS_VIDEO_WINDOW_SET_SELECTED_OPTION =
    'SETTINGS_VIDEO_WINDOW_SET_SELECTED_OPTION';
